/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { MenuItem, Box, Tooltip, IconButton } from "@mui/material";

import { Delete, Edit } from "@mui/icons-material";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { getData, postData, putData } from "utils/Gateway";

import ProjectListHeader from "../ProjectListHeader/ProjectListHeader";
import AddLabelModal from "components/Common/Modal/AddLabelModal";
import ProjectListFilterPopup from "../Popup/ProjectListFilterPopup";
import { assetImages } from "constants";
import DeleteProjectWarningModal from "../Modal/DeleteProjectWarningModal";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import ProjectManagementCommonHeader from "components/ProjectManagementComponents/Common/Header/ProjectManagementCommonHeader";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import LoadingSkeleton from "components/Common/ListLoadingSkeleton/LoadingSkeleton";
import { replaceListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import AddCompanyModal from "components/Common/Modal/AddCompanyModal";
import AddFollowerModal from "components/Common/Modal/AddFollowerModal";
// import AddProjectPopup from "../Popup/AddProjectPopup";

const ProjectListBody = () => {
  const params = useParams();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const moduleAccess = localStorage.getItem("moduleaccess");

  const { t, i18n } = useTranslation(); //for translation

  const [tagList, setTagList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [projectList, setProjectList] = useState([]);

  //optionally, you can manage the row selection state yourself
  const [rowSelection, setRowSelection] = useState({});
  const [selectedProjectIds, setSelectedProjectIds] = useState([]);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);

  const [followingProjectCount, setfollowingProjectCount] = useState(0);
  const [totalTaskCount, settotalTaskCount] = useState(0);
  const [totalLogsCount, settotalLogsCount] = useState(0);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);
  const [reloadData, setReloadData] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  //alert requirements
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  //function for get all tags
  const getAllTags = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL + url.API_GET_ALL_TAGS + `?token=${token}`;

      const response = await getData(requestUrl);

      console.log(response);

      if (response.status) {
        setTagList(response.data);
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    }
  };

  //function for get project list
  const getProjectList = async () => {
    setRowSelection({});
    setSelectedProjectIds([]);

    try {
      setIsLoading(true);

      let requestUrl = `${url.API_BASE_URL}${url.API_GET_ALL_PROJECTS}?token=${token}&userrolestring=${userInfo.role.slug}`;

      if (params.userid) {
        requestUrl = requestUrl + `&projectuserid=${params.userid}`;
      }

      const response = await getData(requestUrl);

      console.log("project list response ------>", response);

      setIsLoading(false);

      if (response.status) {
        setMessageType("success");
        setProjectList(response.data);

        //get total tasks
        const getSumOfTasks = response.data.reduce((acc, curr) => {
          return acc + curr.taskcount;
        }, 0);

        settotalTaskCount(getSumOfTasks);

        //get total logs
        const getSumOfLogs = response.data.reduce((acc, curr) => {
          return acc + curr.logscount;
        }, 0);

        settotalLogsCount(getSumOfLogs);
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  //function for get filtered project list
  const getFilteredProjectList = async () => {
    try {
      setIsLoading(true);

      let requestUrl =
        url.API_BASE_URL + url.API_GET_FILTERED_PROJECTS + `?token=${token}`;

      console.log("Original jsonFilterQuery:", jsonFilterQuery);

      // Sanitize the jsonFilterQuery
      const sanitizedQuery = jsonFilterQuery.map((filter) => {
        if (
          (filter.operator === "includes" || filter.operator === "excludes") &&
          Array.isArray(filter.value)
        ) {
          return {
            ...filter,
            value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
          };
        }
        return filter;
      });

      console.log("Sanitized jsonFilterQuery:", sanitizedQuery);

      const filterData = {
        filters: sanitizedQuery,
      };

      const response = await postData(requestUrl, filterData);

      setIsLoading(false);

      console.log("json filter query response ------->", response);

      if (response.status) {
        setMessageType("success");
        setProjectList(response.data);

        //get total tasks
        const getSumOfTasks = response.data.reduce((acc, curr) => {
          return acc + curr.taskcount;
        }, 0);

        settotalTaskCount(getSumOfTasks);

        //get total logs
        const getSumOfLogs = response.data.reduce((acc, curr) => {
          return acc + curr.logscount;
        }, 0);

        settotalLogsCount(getSumOfLogs);
      } else {
        setMessageType("error");
      }
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }
    setShowAlert(true);
  };

  //function for change rank
  const rankInputChangeHandler = (row, value) => {
    const updatedProjectList = [...projectList];

    const rowIndex = updatedProjectList.findIndex(
      (projectData) => projectData._id === row.original._id
    );

    if (rowIndex !== -1) {
      updatedProjectList[rowIndex].rank = value;
      setProjectList(updatedProjectList);
    }
  };

  //function for update rank
  const updateRankHandler = async (e) => {
    if (selectedProjectIds.length > 0) {
      try {
        const projectListToBeUpdate = projectList.filter((item) =>
          selectedProjectIds.includes(item._id)
        );

        let projectData = {
          projectlist: projectListToBeUpdate,
        };

        let requestURL =
          url.API_BASE_URL + url.API_UPDATE_BULK_PROJECT + `?token=${token}`;

        const response = await putData(requestURL, projectData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setSelectedProjectIds([]);
            setRowSelection({});
          }, 1500);
        } else {
          setMessageType("error");
          setSelectedProjectIds([]);
          setRowSelection({});
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select project for update");
    }
    setShowAlert(true);
  };

  //function for delete project bulk
  const deleteBulkProjectHandler = async () => {
    if (selectedProjectIds.length > 0) {
      try {
        const projectListToBeDelete = projectList.filter((item) =>
          selectedProjectIds.includes(item._id)
        );

        let projectData = {
          projectlist: projectListToBeDelete,
        };

        let requestURL =
          url.API_BASE_URL + url.API_DELETE_BULK_PROJECT + `?token=${token}`;

        const response = await putData(requestURL, projectData);

        console.log(response);

        if (response.status) {
          setMessageType("success");

          setTimeout(() => {
            setProjectList((prevList) =>
              prevList.filter((item) => !selectedProjectIds.includes(item._id))
            );
          }, 1500);
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please select project for delete");
    }
    setShowAlert(true);
  };

  //function for remove tag from project
  const removeTagFromProject = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_PROJECT;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      // console.log("response in remove tag from lead------->", data);

      if (data) {
        afterModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedProjectId(null);
      }, 1000);
    }
  };

  //function for after modal close
  const afterModalActionClose = (data = []) => {
    setTimeout(() => {
      setProjectList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  //function for reset filter
  const resetFilterData = () => {
    setJsonFilterQuery([]);
    setIsFilterReset(true);
    setReloadData(true);
  };

  const onCancelProjectWarning = () => {
    setRowSelection({});
    setSelectedProjectIds([]);
  };

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getFilteredProjectList();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    if (reloadData) {
      getProjectList();
      setReloadData(false);
    }
  }, [reloadData]);

  useEffect(() => {
    getProjectList();
    getAllTags();
  }, []);

  /*
   * Material React Table Column and States -----------------------------------------------------------
   *---------------------------------------------------------------------------------------------------
   */
  const columns = useMemo(
    () => [
      {
        accessorKey: "title",
        header: t("Title"),
        size: 250,
      },
      {
        accessorKey: "tagstring",
        header: t("Label"),
        size: 300,
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.taglist.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.taglist.map((tag, index) => (
                    <li key={index} className="d-inline-flex">
                      <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                        <span className="badge-text fs-xs fw-medium me-1">
                          {tag.title}
                        </span>
                        <Link
                          to="#"
                          className={`${
                            tag.moderator.toString() ===
                              userInfo._id.toString() ||
                            userInfo.role.slug === "ADMIN" ||
                            userInfo.role.slug === "SUPER_ADMIN"
                              ? "d-block"
                              : "d-none"
                          }`}
                          onClick={() => {
                            setSelectedProjectId(row.original._id);
                            setSelectedTagId(tag._id);
                            removeTagFromProject([tag._id], row.original._id);
                          }}
                        >
                          {selectedTagId &&
                          selectedTagId === tag._id &&
                          selectedProjectId &&
                          selectedProjectId === row.original._id ? (
                            <div
                              className="spinner-border spinner-border-sm text-primary ms-1"
                              role="status"
                              style={{ height: "12px", width: "12px" }}
                            >
                              <span className="visually-hidden">
                                Loading...
                              </span>
                            </div>
                          ) : (
                            <span
                              className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                              style={{ cursor: "pointer" }}
                            >
                              cancel
                            </span>
                          )}
                        </Link>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() => setSelectedProjectIds([row.original._id])}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      {
        accessorKey: "rank",
        header: "Rank",
        Cell: ({ row }) => (
          <div className="ranking border-bottom-0">
            {userInfo.role.slug === "ADMIN" ||
            userInfo.role.slug === "SUPER_ADMIN" ||
            row.original.moderator.toString() === userInfo._id.toString() ? (
              <input
                type="text"
                className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none"
                style={{ width: "80px" }}
                value={row.original.rank}
                onChange={(e) => rankInputChangeHandler(row, e.target.value)}
              />
            ) : (
              <p className="form-control fs-sm text-gray bg-white py-2 border-gray-300 shadow-none ps-3">
                {row.original.rank}
              </p>
            )}
          </div>
        ),
      },
      {
        accessorKey: "owner",
        header: t("Owner"),
        size: 200,
        Cell: ({ row }) => (
          <div className="d-flex border-bottom-0">
            <div className="d-flex align-items-center gap-2">
              <div
                className="avatar rounded-circle overflow-hidden"
                style={{ width: "25px", height: "25px" }}
              >
                <img
                  src={
                    row.original.ownerimage == ""
                      ? assetImages.defaultUser
                      : url.SERVER_URL + row.original.ownerimage
                  }
                  alt="admin"
                  className="w-100 h-100 object-fit-cover object-center"
                />
              </div>
              <p>{row.original.owner}</p>
            </div>
            <button
              onClick={() => {
                createContactChatHandler(
                  row.original.moderator,
                  "MOD_PROJECT",
                  row.original._id,
                  row.original.title
                );
              }}
              className={
                row.original.moderator?.toString() === userInfo._id.toString()
                  ? "d-none"
                  : "d-flex align-items-center ms-auto border-0 bg-light"
              }
            >
              <span className="d-block material-symbols-outlined icon-md text-primary">
                chat
              </span>
            </button>
          </div>
        ),
      },
      {
        accessorKey: "projectstartdate",
        header: t("Start Date"),
      },
      {
        accessorKey: "projectenddate",
        header: t("End Date"),
      },
      {
        accessorKey: "companyname",
        header: t("Company"),
      },
      {
        accessorKey: "membercount",
        header: t("Members"),
      },
      {
        accessorKey: "sectioncount",
        header: t("Sections"),
      },
      {
        accessorKey: "taskcount",
        header: t("Tasks"),
      },
      {
        accessorKey: "loghours",
        header: t("Log Hours"),
      },
      {
        accessorKey: "totalcost",
        header: t("Cost"),
      },
    ],
    [projectList, selectedTagId, i18n.language]
  );

  useEffect(() => {
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );

    if (selectedIdsArray.length > 0) {
      setSelectedProjectIds(selectedIdsArray);
    } else {
      setSelectedProjectIds([]);
    }
  }, [rowSelection]);

  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    moduleAccess.includes("MOD_PROJECT")
  ) {
    return (
      <div id="content_wrapper">
        <section className="survey-wrapper bg-white pb-5">
          <ProjectManagementCommonHeader componentName="projectlist" />

          <div className="container-fluid px-lg-5">
            {/* -------- header area ---------- */}
            <ProjectListHeader
              userInfo={userInfo}
              moduleAccess={moduleAccess}
              reloadList={resetFilterData}
              changeStatusHandler={deleteBulkProjectHandler}
              updateRankHandler={updateRankHandler}
              projectList={projectList}
              followingProjectCount={followingProjectCount}
              totalTaskCount={totalTaskCount}
              totalLogsCount={totalLogsCount}
              jsonFilterQuery={jsonFilterQuery}
              selectedProjectIds={selectedProjectIds}
            />

            {isLoading ? (
              <LoadingSkeleton />
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={projectList} // data from api to be displayed
                  enableGrouping
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => row._id} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{ rowSelection }} //pass our managed row selection state to the table to use
                  enableRowActions // show the action column
                  renderRowActionMenuItems={({ row }) => [
                    <MenuItem key="view">
                      <Link
                        className="dropdown-item"
                        to={`/admin/projectmanagement/details/${row.id}`}
                      >
                        {t("View Details")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="copy">
                      <Link
                        className="dropdown-item"
                        to={`/admin/projectmanagement/copyproject/${row.id}`}
                      >
                        {t("Copy Project")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="taxonomy">
                      <Link
                        className="dropdown-item"
                        to={`/admin/projectmanagement/taxonomies/${row.id}`}
                      >
                        {t("View Taxonomies")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="member">
                      <Link
                        className="dropdown-item"
                        to={`/admin/projectmanagement/members/${row.id}`}
                      >
                        {t("View Members")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="task">
                      <Link
                        className="dropdown-item"
                        to={`/admin/projectmanagement/tasksection/${row.id}`}
                      >
                        {t("View Task")}
                      </Link>
                    </MenuItem>,
                    <MenuItem key="log">
                      <Link
                        className="dropdown-item"
                        to={`/admin/projectmanagement/logs/${row.id}`}
                      >
                        {t("View Logs")}
                      </Link>
                    </MenuItem>,
                  ]} // action columns menu items
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>
        </section>

        {/* ========= popups and modals area ======== */}
        {/* -------- add label modal ---------- */}
        <AddLabelModal
          moduleName="project"
          selectedIds={selectedProjectIds}
          afterTagModalClose={afterModalActionClose}
          onModalClose={() => {
            setRowSelection({});
            setSelectedProjectIds([]);
          }}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
          moduleSlug="MOD_PROJECT"
        />

        <DeleteProjectWarningModal
          onDelete={deleteBulkProjectHandler}
          onCancelDelete={onCancelProjectWarning}
        />

        {/* ---------- filter popup ---------- */}
        <ProjectListFilterPopup
          setJsonFilterQuery={setJsonFilterQuery}
          reloadProjectList={resetFilterData}
          moduleSlug="projectlist"
          isFilterReset={isFilterReset}
          setIsFilterReset={setIsFilterReset}
        />

        <AddFollowerModal
          moduleName="projectlist"
          selectedIds={selectedProjectIds}
          afterModalClose={afterModalActionClose}
          onModalClose={() => {
            setRowSelection({});
            setSelectedProjectIds([]);
          }}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        {/* ---------- add company modal ------------ */}
        <AddCompanyModal
          moduleName="project"
          selectedIds={selectedProjectIds}
          afterModalClose={afterModalActionClose}
          onModalClose={() => {
            setRowSelection({});
            setSelectedProjectIds([]);
          }}
          setShowAlert={setShowAlert}
          setAlertMessage={setAlertMessage}
          setMessageType={setMessageType}
        />

        {showAlert && (
          <AlertNotification
            showAlert={showAlert}
            message={alertMessage}
            alertType={messageType}
            onClose={onAlertClose}
          />
        )}
      </div>
    );
  } else {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <div className="empty_access text-center">
            <div className="empty_pic mb-4">
              {" "}
              <img src={assetImages.emptyVector} alt="" />
            </div>
            <div className="empty_text">
              <p className="fs-lg text-gray fw-semibold mb-4">
                {t("Sorry....! You don't have privilege to see this content")}
              </p>
            </div>
          </div>
        </section>
      </div>
    );
  }
};

export default ProjectListBody;
